export default [
  
{
   "city":"г. Благовещенск",
   "address":"ул. Кольцевая, д.15",
   "coords":[
      50.303019,
      127.552782
   ]
},
{
   "city":"г. Благовещенск",
   "address":"ул. Магистральная",
   "coords":[
      "50.290775",
       "127.529243"
   ]
},
{
   "city":"г. Благовещенск",
   "address":"ул. Лазо",
   "coords":[
      "50.268465",
       "127.56842"
   ]
},
{
   "city":"с. Тамбовка",
   "address":"въезд в село, 71",
   "coords":[
      "50.116574",
      "128.046062"
   ]
},
{
   "city":"г. Благовещенск",
   "address":"Новотроицкое ш",
   "coords":[
      "50.304404",
       "127.532709"
   ]
},
{
   "city":"г. Благовещенск",
   "address":"ул. Мухина-ш. Игнатьевское",
   "coords":[
      "50.2899758086683",
       "127.518015762673"
   ]
},

{
   "city":"г. Благовещенск",
   "address":"ул. Пионерская - ул. Кольцевая",
   "coords":[
    "50.303578",
      "127.543341"
   ]
},
{
   "city":"г. Благовещенск",
   "address":"ул. Театральная-пер. Строителей",
   "coords":[
    "50.309077",
     "127.566081"
   ]
},
{
   "city":"г. Благовещенск",
   "address":"ул. Красноармейская - ул. Батарейная",
   "coords":[
     "50.27185",
      "127.493446"
   ]
},
{
   "city":"г. Благовещенск",
   "address":"ул. Чайковского",
   "coords":[
    "50.285171",
     "127.563195"
   ]
},
{
   "city":"г. Благовещенск",
   "address":"ул. Островского - ул. Октябрьская",
   "coords":[
     "50.270296",
      "127.541195"
   ]
},
{
   "city":"г. Благовещенск",
   "address":"ул. Василенко, д.38",
   "coords":[
    "50.300842",
     "127.504663"
   ]
},
{
   "city":"г. Белогорск",
   "address":"л. Кирова, д. 310",
   "coords":[
      "50.896395",
       "128.538333"
   ]
},
{
   "city":"п. Новобурейский",
   "address":"Трасса Чита-Хабаровск",
   "coords":[
      "49.796769",
       "129.908596"
   ]
},
{
   "city":"г. Владивосток",
   "address":"Партизанский пр-т, 50",
   "coords":[
     "43.12838",
      "131.9048"
   ]
},
{
   "city":"г. Владивосток",
   "address":"ул. Калинина, 20",
   "coords":[
   "43.10197",
      "131.91267"
   ]
},
{
   "city":"г. Владивосток",
   "address":"ул. Крыгина, 111",
   "coords":[
    "43.08188",
      "131.85211"
   ]
},
{
   "city":"г. Владивосток",
   "address":"ул. Луговая, 89а",
   "coords":[
      "43.12991",
       "131.94012"
   ]
},
{
   "city":"г. Владивосток",
   "address":"ул. Маковского, 30",
   "coords":[
      "43.20131",
      "131.95083"
   ]
},
{
   "city":"г. Владивосток",
   "address":"ул. Маковского, 280",
   "coords":[
     "43.23305",
       "132.02943"
   ]
},
{
   "city":"г. Артем",
   "address":"ул. Фрунзе, 50",
   "coords":[
      "43.34134",
       "132.13525"
   ]
},
{
   "city":"Хасанский район",
   "address":"п. Славянка, ул. Калинина, 34",
   "coords":[
      "42.874694",
       "131.367866"
   ]
},
{
   "city":"г. Уссурийск",
   "address":"ул. Краснознаменная, 167",
   "coords":[
      "43.810299",
       "131.953833"
   ]
},
{
   "city":"г. Уссурийск",
   "address":"ул. Раковская, 2в",
   "coords":[
      "43.79305",
       "131.9856"
   ]
},
{
   "city":"с. Сибирцево",
   "address":"ул. Пролетарская, 58",
   "coords":[
      "44.20151",
       "132.450352"
   ]
},
{
   "city":"с. Хороль",
   "address":"ул. Ленинская, 178",
   "coords":[
      "44.44218",
       "132.07601"
   ]
},
{
   "city":"г. Спасск-Дальний",
   "address":"ул. Хабаровская, 16",
   "coords":[
      "44.571538",
       "132.842302"
   ]
},
{
   "city":"г. Спасск Дальний",
   "address":"ул. Советская, 282",
   "coords":[
      "44.5813112880205",
       "132.796035191788"
   ]
},
{
   "city":"п. Кировский",
   "address":"ул. Гагарина, 93",
   "coords":[
      "45.104076",
       "133.493145"
   ]
},
{
   "city":"п. Лучегорск",
   "address":"тр. Хабаровск - Владивосток",
   "coords":[
      "46.444879",
       "134.280867"
   ]
},
{
   "city": "г. Дальнереченск",
   "address":"ул. Тухачевского",
   "coords":[
     "45.924278",
       "133.772414"
   ]
},
{
   "city":"г. Лесозаводск",
   "address":"ул. Григоренко, 24",
   "coords":[
      "45.463927",
       "133.407524"
   ]
},
{
   "city":"г. Арсеньев",
   "address":"ул. Стахановская, 155",
   "coords":[
      "44.134155",
       "133.271883"
   ]
},
{
   "city":"п. Кавалерово",
   "address":"ул. Первомайская, 5",
   "coords":[
     "44.264271",
       "135.04162"
   ]
},
{
   "city":"г. Дальнегорск",
   "address":"ул. 50 лет Октября, 243а",
   "coords":[
    "44.55499",
      "135.61662"
   ]
},
{
   "city":"г. Арсеньев",
   "address":"расса Стахановка - Новиково",
   "coords":[
     "44.140797",
       "133.284575"
   ]
},
{
   "city":"г. Арсеньев",
   "address":"ул. Островского",
   "coords":[
     "44.158818",
       "133.275545"
   ]
},
{
   "city":"с. Чугуевка",
   "address":"ул. Титова 59а",
   "coords":[
      "44.17553",
       "133.87868"
   ]
},
{
   "city":"г. Владивосток",
   "address":"ул. 2-я Шоссейная (р-н Кока-Кола)",
   "coords":[
     "43.283908",
       "132.065949"
   ]
},
{
   "city":"г. Находка",
   "address":"ул. Шоссейная, 231",
   "coords":[
    "42.855042",
      "132.973215"
   ]
},
{
   "city":"г. Находка",
   "address":"ул. Мичманская, 1а",
   "coords":[
     "42.835772",
       "132.876567"
   ]
},
{
   "city":"г. Находка",
   "address":"ул. Шевченко",
   "coords":[
      "42.84511",
       "132.93456"
   ]
},
{
   "city":"г. Находка",
   "address":"Автовокзал",
   "coords":[
      "42.82847",
       "132.89644"
   ]
},
{
   "city":"г. Владивосток",
   "address":"пр-т 100-летия Владивостока ,103б",
   "coords":[
   "43.160548",
      "131.91168"
   ]
},
{
   "city":"г. Петропавловск-камчатский",
   "address":"ул. Тушканова",
   "coords":[
   "53.0628",
       "158.6272"
   ]
},
{
   "city":"г.Елизово",
   "address":"5-я стройка, 3-й км. объездной дороги",
   "coords":[
    "53.2076",
       "158.4167"
   ]
},
{
   "city":"г. Вилючинск",
   "address":"л. Лесная 1",
   "coords":[
     "52.9426875713907",
       "158.408019"
   ]
},
{
   "city":"Елизовский район, п. Сокоч",
   "address":"ул. Дорожная 1",
   "coords":[
 "53.1564140712766",
       "157.6857645"
   ]
},
{
   "city":"п.Усть-Большерецк",
   "address":"ул. Садовая д.7",
   "coords":[
    "52.8273421990957",
       "156.273089949074"
   ]
},
{
   "city":"г. Петропавловск-Камчатский",
   "address":"11 км. объездной дороги",
   "coords":[
      "53.0902",
       "158.6305"    ]
},
{
   "city":"г.Елизово",
   "address":"5-я стройка, 3-й км. объездной дороги",
   "coords":[
    "53.2076",
       "158.4167"
   ]
},
{
   "city":"Елизовский район, п. Николаевка",
   "address":"ул. Советская д.48",
   "coords":[
     "53.0429",
       "158.3256"
   ]
},
{
   "city":"г. Петропавловск-Камчатский",
   "address":"ул. Ак. Королёва д. 71",
   "coords":[
      "53.065154049224",
       "158.642478502655"
   ]
},
{
   "city":"г. Петропавловск-Камчатский",
   "address":"ул. Победы, 67/1",
   "coords":[
   "53.0727",
       "158.5869"
   ]
},
{
   "city":"г. Петропавловск-Камчатский",
   "address":"ул. Циолковского д.2",
   "coords":[
 "53.0464556671135",
    "158.664084271011"
   ]
},
{
   "city":"г. Усть-Камчатск",
   "address":"",
   "coords":[
    "56.2337",
       "162.5397"
   ]
},
{
   "city":"г. Улан-Удэ",
   "address":"ул. Кабанская, 52",
   "coords":[
   "51.851302",
      "107.50759"
   ]
},
{
   "city":"г. Улан-Удэ",
   "address":"ул.Ботаническая, 8а",
   "coords":[
     "51.841736",
       "107.638455"
   ]
},
{
   "city":"г. Улан-Удэ",
   "address":"пр.Автомобилистов 4д",
   "coords":[
   "51.831451",
       "107.65642"
   ]
},
{
   "city":"г. Улан-Удэ",
   "address":"ул.Тополиная 30",
   "coords":[
 "51.8171",
   "107.5015"
   ]
},
{
   "city":"г. Улан-Удэ",
   "address":"ул.Трубачеева 15а",
   "coords":[
     "51.813616",
       "107.596065"
   ]
},
{
   "city":"с. Сотниково",
   "address":"ул.Магистральная 47",
   "coords":[
    "51.866289",
       "107.488353"
   ]
},
{
   "city":"с. Нижний Саянтуй",
   "address":"ул. Солнечная, д. 62",
   "coords":[
     "51.7307",
       "107.5218"
   ]
},
{
   "city":"г. Улан-Удэ",
   "address":"станция Тальцы «Товарный двор», дом 2",
   "coords":[
     "51.8278145072131",
       "107.749360081163"
   ]
},
{
   "city":"г. Улан-Удэ",
   "address":"ул. Ключевская, 142",
   "coords":[
    "51.8211573697281",
       "107.666559864418"
   ]
},
{
   "city":"г. Хабаровск",
   "address":"ул. Шелеста, д.1",
   "coords":[
    "48.51171",
       "135.07068"
   ]
},
{
   "city":"г. Хабаровск",
   "address":"ул. Тихоокеанская, д. 32",
   "coords":[
      "48.49408",
       "135.040285"
   ]
},
{
   "city":"г. Хабаровск",
   "address":"ул. Краснореченская, д. 231",
   "coords":[
   "48.45654",
       "135.101064"
   ]
},
{
   "city":"г. Хабаровск",
   "address":"Чернореченское ш., д. 2А",
   "coords":[
    "48.508689",
       "135.146586"
   ]
},
{
   "city":"г. Хабаровск",
   "address":"ул. Воронежская, д. 17",
   "coords":[
     "48.501502",
       "135.066463"
   ]
},
{
   "city":"г. Хабаровск",
   "address":"Восточное ш., д. 52",
   "coords":[
     "48.477952",
       "135.117018"
   ]
},
{
   "city":"г. Хабаровск",
   "address":"г. Хабаровск, ул. Воронежская, 17",
   "coords":[
      "48.501502",
      "135.066463"
   ]
},
{
   "city":"г. Хабаровск",
   "address":"ул. Карла Маркса - ул. Большая",
   "coords":[
      "48.498204",
       "135.095538"
   ]
},
{
   "city":"г. Хабаровск",
   "address":"ул. Даниловского М.П., д. 12а",
   "coords":[
     "48.533162",
       "135.044712"
   ]
},
{
   "city":"г. Хабаровск",
   "address":"ул. Победы, д. 66, р-н Онкоцентра",
   "coords":[
    "48.557457",
       "135.061003"
   ]
},
{
   "city":"г. Биробиджан",
   "address":"ул. Советская, д. 70г",
   "coords":[
    "48.771952",
       "132.944763"
   ]
},
{
   "city":"г. Комсомольск-на-Амуре",
   "address":"Северное ш., д. 1/3",
   "coords":[
   "50.563465",
       "137.016093"
   ]
},
{
   "city":"г. Комсомольск-на-Амуре",
   "address":"Северное ш., д. 44/3",
   "coords":[
    "50.580757",
       "136.992559"
   ]
},
{
   "city":"г. Хабаровск",
   "address":"ул. Металлистов, д. 7",
   "coords":[
    "48.49627",
       "135.048943"
   ]
},
{
   "city":"г. Хабаровск",
   "address":"Матвеевское ш., д. 51",
   "coords":[
    "48.524537",
       "135.164364"
   ]
},
{
   "city":"г. Хабаровск",
   "address":"ул. Дистанционная",
   "coords":[
    "48.546016",
       "135.026768"
   ]
},
{
   "city":"г. Хабаровск",
   "address":"ул. Тихоокеанская, д. 189б",
   "coords":[
      "48.541448",
       "135.043049"
   ]
},
{
   "city":"п. Переяславка",
   "address":"59 км трассы Хабаровск - Владивосток",
   "coords":[
     "47.971795",
       "135.081797"
   ]
},
{
   "city":"г. Вяземский",
   "address":"ул. Шоссейная, д. 1а",
   "coords":[
    "47.528163",
       "134.785541"
   ]
},
{
   "city":"п. Теплоозёрск",
   "address":"ул. Дачная",
   "coords":[
   "49.0149825202391",
       "131.860020372189"
   ]
},
]